module.exports = __webpack_public_path__ + "img/offer-delivery-truck.543e4861.svg";